import { render } from "./DoNotContactPanel.vue?vue&type=template&id=10aa4442"
import script from "./DoNotContactPanel.vue?vue&type=script&lang=js"
export * from "./DoNotContactPanel.vue?vue&type=script&lang=js"

import "./DoNotContactPanel.vue?vue&type=style&index=0&id=10aa4442&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__